let convertInterval = setInterval(() => {
    injectConvertMoney();
}, 300);

function injectConvertMoney(event) {
    const container = document.getElementById('opus-shadow-container');
    const shadowRoot = container?.shadowRoot;
    
    const root = shadowRoot ? shadowRoot : document;

    const moneySpans = root.querySelectorAll('.cd-modal-container.free-gift-modal span.money.opus-money');
    if (!moneySpans.length) return;

    moneySpans.forEach(span => {
        const existsCustom = span.parentElement.querySelector('.opus-custom-price');
        if (existsCustom) return;

        const converted = window.OpusConvertMoney(1);

        const newSpan = document.createElement('span');
        newSpan.className = "money opus-money opus-custom-price";
        newSpan.textContent = converted;

        span.insertAdjacentElement('afterend', newSpan);
    });
}

window.addEventListener('OpusCartChange', injectConvertMoney);
window.addEventListener('OpusOpenCartState', injectConvertMoney);
